import React, { useState } from 'react';
import { WrappedButton, WrappedButtonType } from './button';
import { WrappedCheckbox } from './input';
import Typography from './Typography.component';

type TodoTaskItemProps = {
	header: string;
	text: string;
	buttonText: string;
	onButtonClick: () => void;
	onClose: () => void;
	onCheck: (checked: boolean) => void;
	isCompleted?: boolean;
	dataqa?: string;
};

const TodoTaskItem = ({
	header,
	text,
	buttonText,
	onButtonClick,
	onClose,
	onCheck,
	isCompleted = false,
	dataqa,
}: TodoTaskItemProps) => {
	const [checked, setChecked] = useState<boolean>(isCompleted);

	const handleCheckboxChange = (e: { checked: boolean }) => {
		const newChecked = e.checked;
		setChecked(newChecked);
		if (onCheck) {
			onCheck(newChecked);
		}
	};

	return (
		<div className="todo-task-item">
			<div className="todo-task-item-checkbox-container">
				<WrappedCheckbox
					checked={checked}
					onChange={handleCheckboxChange}
					inputId={`${dataqa}-checkstate`}
					dataqa={`${dataqa}-checkstate`}
				>
					<span
						className={`todo-task-item-checkstate ${checked ? 'checked' : 'unchecked'}`}
					/>
				</WrappedCheckbox>
			</div>

			<div className="todo-task-item-content">
				<div className="todo-task-item-header-row">
					<Typography.HeadingLabel className="todo-task-item-header">
						{header}
					</Typography.HeadingLabel>
					<div className="todo-task-item-actions">
						<div className="todo-task-item-button">
							<WrappedButton
								label={buttonText}
								buttonType={WrappedButtonType.TertiaryGhost}
								dataqa={dataqa}
								onClick={onButtonClick}
							/>
						</div>
						<div className="todo-task-item-close">
							<WrappedButton
								buttonType={WrappedButtonType.TertiaryGhost}
								dataqa={`${dataqa}-todo-task-item-close`}
								onClick={onClose}
							/>
						</div>
					</div>
				</div>
				<Typography.P className="todo-task-item-text">{text}</Typography.P>
			</div>
		</div>
	);
};

export default TodoTaskItem;
